import { render, staticRenderFns } from "./AssociatePremiumModal.vue?vue&type=template&id=782ccbf6&scoped=true"
import script from "./AssociatePremiumModal.vue?vue&type=script&lang=ts"
export * from "./AssociatePremiumModal.vue?vue&type=script&lang=ts"
import style0 from "./AssociatePremiumModal.vue?vue&type=style&index=0&id=782ccbf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782ccbf6",
  null
  
)

export default component.exports